export default __webpack_public_path__ + "static/media/avat.2fda6558.png";